
import React,{useEffect,useState} from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import './notes.css'
import {useDispatch,useSelector} from 'react-redux'


import Note4 from './Note4'
import Notetype3 from './Notetype3'
import Note5 from './Note5'
import Note8 from './Note8'
import Pattern6 from './Pattern6';
import Pattern3 from './Pattern3';
import Pattern5 from './Pattern5';
import Pattern5b from './Pattern5b';
import Pattern7 from './Pattern7';
import NoteEquiteShareCaptial from './NoteEquiteShareCaptial';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    minHeight: '50vh',

    
  },
  tabs: {
    maxHeight:'100vh',
    borderRight: `1px solid ${theme.palette.divider}`,
    paddingTop:'3rem',
    paddingBottom:'3rem',
    background:'linear-gradient(45deg, transparent, #E5EEEE)',    
    color:'Black',
    fontSize:'1rem',
    width: '260px',
  },
  tab: {
      padding: '12px 12px',
      overflow: 'hidden',
      position: 'relative',
      fontSize: '5px',
      boxSizing: 'border-box',
      minHeight: '55px',
      textAlign: 'center',
      flexShrink: 0,
      fontWeight: "500",
      letterSpacing: '0.02857em',
      textTransform: 'none',
  },
  TabPanel: {
    width:'100%'
  },
}));

const heading = {
  width:"100%",
  height:'50px',
  backgroundColor:'#E5EEEE',
  position:'sticky',
  top:'80px',
  display:'flex',
  justifyContent:'center',
  alignItems:'center',
  // border:'1px solid teal'

}

const headingText = {
  fontSize:'1.2 rem',
  fontWeight:'700'

}

export default function  VerticalTabs(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [value, setValue] = useState(1);
  const [math, setMath] = useState('');
  const NoteNo = useSelector(initialState => initialState.reducer.blNoteNo) 
  const handleChange = (event, newValue) => {
    setValue(newValue);
    // props.setNoteName(newValue)
  };

  // useEffect(() => {
  //   console.log(props.note,'propnote propnote propnote propnote')
  //   // setValue(props.note)
  // }, [])

  useEffect(() => {
    // console.log(props.note,'propnote propnote propnote propnote')
    setValue(NoteNo)
  }, [NoteNo])



  return (
    <div className={classes.root}>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        className={`${classes.tabs} bsnotetab`}
        
      >
        {/* <Tab className={classes.tab} label="*" {...a11yProps(0)}  />
        <Tab className={classes.tab} label="**" {...a11yProps(1)} /> */}
        {/* //CURRENT ASSETS */}
        <Tab className={classes.tab} label="Note - Property, Plant & Equipment " {...a11yProps(0)} />
        {/* <Tab className={classes.tab} label="Note - Leases" {...a11yProps(1)} /> */}
        <Tab className={classes.tab} label="Note - Capital Work-In Progress" {...a11yProps(1)} />
        <Tab className={classes.tab} label="Note - Investment Properties" {...a11yProps(2)} />
        <Tab className={classes.tab} label="Note - Goodwill" {...a11yProps(3)} />

        {/* new node added   */}
        <Tab className={classes.tab} label="Note - Intangible assets under development" {...a11yProps(4)} />

        <Tab className={classes.tab} label="Note - Other Intangible Assets" {...a11yProps(5)} />

        {/* new node added  */}
        <Tab className={classes.tab} label="Note - Biological assets other than bearer plants" {...a11yProps(6)} />

        <Tab className={classes.tab} label="Note - Financial Assets - Investments" {...a11yProps(7)} />
        <Tab className={classes.tab} label="Note - Financial Assets - Loans" {...a11yProps(8)} />
        <Tab className={classes.tab} label="Note - Financial Assets - Other Financial Assets" {...a11yProps(9)} />
        <Tab className={classes.tab} label="Note - Contract assets" {...a11yProps(10)} />
        <Tab className={classes.tab} label="Note - Investments Accounted for using the equity method" {...a11yProps(11)} />
        <Tab className={classes.tab} label="Note - Inventories" {...a11yProps(12)} />
        <Tab className={classes.tab} label="Note - Financial Assets - Trade Receivables" {...a11yProps(13)} />
        <Tab className={classes.tab} label="Note - Financial Assets - Cash and cash equivalents" {...a11yProps(14)} />
        <Tab className={classes.tab} label="Note - Other current assets" {...a11yProps(15)} />
        <Tab className={classes.tab} label="Note - Assets held-for-sale / Assets included in disposal group(s) held-for-sale" {...a11yProps(16)} />
        <Tab className={classes.tab} label="Note - Equity Share Capital" {...a11yProps(17)} />
        {/* <Tab className={classes.tab} label="Note - other equity - equity component of compound financial instruments" {...a11yProps(18)} /> */}
        <Tab className={classes.tab} label="Note - Instruments entirely equity in nature" {...a11yProps(18)} />
        <Tab className={classes.tab} label="Note - Share application money pending allotment" {...a11yProps(19)} />
        <Tab className={classes.tab} label="Note - Other equity" {...a11yProps(20)} />
        <Tab className={classes.tab} label="Note - Non Controlling Interest" {...a11yProps(21)} />
        <Tab className={classes.tab} label="Note - Financial Liabilities - Borrowings" {...a11yProps(22)} />
        <Tab className={classes.tab} label="Note - Financial liabilities - Other Financial Liabilities" {...a11yProps(23)} />
        <Tab className={classes.tab} label="Note - Provisions" {...a11yProps(24)} />
        <Tab className={classes.tab} label="Note - Current tax assets" {...a11yProps(25)} /> 
        {/* <Tab className={classes.tab} label="Note - Employee benefit obligations" {...a11yProps(25)} /> */}
        <Tab className={classes.tab} label="Note - Deferred tax liabilities" {...a11yProps(26)} />
        {/* <Tab className={classes.tab} label="Note - Government grants" {...a11yProps(27)} /> */}
        <Tab className={classes.tab} label="Note - Liabilities directly associated with assets classified as held for sale" {...a11yProps(27)} />
        <Tab className={classes.tab} label="Note - Other Non-Current Liabilities" {...a11yProps(28)} />
        <Tab className={classes.tab} label="Note - Financial Liabilities - Trade Payable" {...a11yProps(29)} />
        <Tab className={classes.tab} label="Note - Contract Liabilities" {...a11yProps(30)} />
        <Tab className={classes.tab} label="Note - Current tax Liabilities" {...a11yProps(31)} />
        <Tab className={classes.tab} label="Note - Other Current Liabilities" {...a11yProps(32)} />
        {/* <Tab className={classes.tab} label="Note - Liabilities directly associated with assets classified as held for sale" {...a11yProps(33)} /> */}
        <Tab className={classes.tab} label="Note - Deferred Tax Assets" {...a11yProps(33)} />
        <Tab className={classes.tab} label="Note - Other non-current Assets" {...a11yProps(34)} /> 
        <Tab className={classes.tab} label="Note - Bank balances other than above" {...a11yProps(35)} /> 
        {/* <Tab className={classes.tab} label="Note - Current tax assets" {...a11yProps(36)} />  */}

      </Tabs>
      <TabPanel  className={classes.TabPanel} value={value} index={0}>
        {/* <Note3 setShowCreateInput={props.setShowCreateInput} setSid={props.setSid} setNid={props.setNid} setNoteNum={props.setNoteNum}/> */}
        {/* <Notetype3 brackets={props.brackets} VALUE={value} setShowCreateInput={props.setShowCreateInput} setSid={props.setSid} setNid={props.setNid} setNoteNum={props.setNoteNum}/> */}
        {/* Temporary */}
        <Note5 heading={"Note - Property, Plant & Equipment"} setShowCreateInput={props.setShowCreateInput} render={props.render}  note='3' FinalStr='SET_NOTE3' NoteStr='note3' setSid={props.setSid} setNid={props.setNid} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
        {/* <Note5 setShowCreateInput={props.setShowCreateInput} setSid={props.setSid} setNid={props.setNid} setNoteNum={props.setNoteNum}/> */}
      </TabPanel>
      {/* <TabPanel  className={classes.TabPanel} value={value} index={1}>
      <div style={heading}>
        <p style={headingText} >Note - (Leases)</p>
      </div>
        <NoteLeases setShowCreateInput={props.setShowCreateInput} setSid={props.setSid} setNid={props.setNid} setNoteNum={props.setNoteNum}/>
      </TabPanel> */}
      <TabPanel  className={classes.TabPanel} value={value} index={1}>
        <Notetype3 heading={"Note - Capital Work-In Progress"} brackets={props.brackets} VALUE={value} scroll='down' setShowCreateInput={props.setShowCreateInput} setSid={props.setSid} setNid={props.setNid} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
        {/* <div  className='some'>Division</div> */}
      </TabPanel>
      <TabPanel   className={classes.TabPanel} value={value} index={2} >
        {/* <Note4 setShowCreateInput={props.setShowCreateInput} setRandom={props.setStr} setMath={setMath} note='4' FinalStr='SET_NOTE7' NoteStr='note7' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}/> */}
        {/* < Note4 setShowCreateInput={props.setShowCreateInput} note = '4' FinalStr='SET_NOTE4' NoteStr='note4' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}/> */}
        <Note5 heading={"Note - Investment Properties"} setShowCreateInput={props.setShowCreateInput}  note='4' FinalStr='SET_NOTE4' NoteStr='note4' setSid={props.setSid} setNid={props.setNid} setNoteNum={props.setNoteNum}projectData={props.projectData}/>

      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={3}>
        <Note5 heading={"Note - Goodwill"} setShowCreateInput={props.setShowCreateInput}  note='5A' FinalStr='SET_NOTE5' NoteStr='note5' setSid={props.setSid} setNid={props.setNid} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
        {/* <Note5 setShowCreateInput={props.setShowCreateInput} setSid={props.setSid} setNid={props.setNid} setNoteNum={props.setNoteNum}/> */}
        {/* <div  className='some'>Division</div> */}
      </TabPanel>

      <TabPanel  className={classes.TabPanel} value={value} index={4}>
        <Note5 heading={"Note - Intangible assets under development"} setShowCreateInput={props.setShowCreateInput}  note='5B' FinalStr='SET_NOTE5' NoteStr='note5' setSid={props.setSid} setNid={props.setNid} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
      </TabPanel>

      <TabPanel  className={classes.TabPanel} value={value} index={5}>
        <Note5 heading={"Note - Other Intangible Assets"} setShowCreateInput={props.setShowCreateInput} note='5' FinalStr='SET_NOTE5' NoteStr='note5' setSid={props.setSid} setNid={props.setNid} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
      </TabPanel>

      <TabPanel  className={classes.TabPanel} value={value} index={6}>
        <Note5 heading={"Note - Biological assets other than bearer plants"} setShowCreateInput={props.setShowCreateInput} note='5C' FinalStr='SET_NOTE5' NoteStr='note5' setSid={props.setSid} setNid={props.setNid} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={7}>
        <Pattern5 heading={"Note - Financial Assets - Investments"}  setShowCreateInput={props.setShowCreateInput} note='6(a)' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={8}>
        <Pattern3 heading={"Note - Financial Assets - Loans"}  setShowCreateInput={props.setShowCreateInput} note = '6(c)'  FinalStr='SET_NOTE6C' NoteStr='note6C' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={9}>
        <Pattern6 heading={"Note - Financial Assets - Other Financial Assets"} name="" setShowCreateInput={props.setShowCreateInput} note = '6(e)'  FinalStr='SET_NOTE6E' NoteStr='note6E' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={10}>
        <div style={heading}>
          {/* some heading here */}
          <p style={headingText} >Note - Contract asset</p>
        </div>
        {/* < Pattern6 name="" setShowCreateInput={props.setShowCreateInput} note = '6A'  FinalStr='SET_NOTE6AA' NoteStr='note6AA' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}/> */}
        {/* Item 9 */}
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={11}>
        <div style={heading}>
          {/* some heading here */}
          <p style={headingText} >Note - Investments Accounted for using the equity method</p>
        </div>
        Item 9
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={12}>
        {/* < Pattern3 setShowCreateInput={props.setShowCreateInput} note = '6(b)'  FinalStr='SET_NOTE6B' NoteStr='note6B' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}/> */}
        <Note8 heading={"Note - Inventories"} setShowCreateInput={props.setShowCreateInput} note='9'  FinalStr='SET_NOTE9' NoteStr='note9' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={13}>
        {/* <Note8 setShowCreateInput={props.setShowCreateInput} note = '6(b)'  FinalStr='SET_NOTE6B' NoteStr='note6B' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}/> */}
        {/* <Pattern6 name="trade_receivables" setShowCreateInput={props.setShowCreateInput} note = '6(b)'  FinalStr='SET_NOTE6E' NoteStr='note6E' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}/> */}
        <Pattern5 name="trade_receivables" setShowCreateInput={props.setShowCreateInput} note = '6(b)'  FinalStr='SET_NOTE6E' NoteStr='note6E' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>

      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={14}>
        < Note8 heading={"Note - Financial Assets - Cash and cash equivalents"} setShowCreateInput={props.setShowCreateInput} note='6(d)' FinalStr='SET_NOTE6D' NoteStr='note6D' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={15}>
        < Note8 heading={"Note - Other current assets"} setShowCreateInput={props.setShowCreateInput} note='10' FinalStr='SET_NOTE10' NoteStr='note10' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={16}>
        < Note8 heading={"Note - Assets held-for-sale / Assets included in disposal group(s) held-for-sale"} setShowCreateInput={props.setShowCreateInput} note='11'  FinalStr='SET_NOTE11' NoteStr='note11' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
        {/* Item 9 16  */}
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={17}>
        <NoteEquiteShareCaptial heading={"Note - Equity Share Capital"}  setShowCreateInput={props.setShowCreateInput} note='40'  FinalStr='SET_NOTE8' NoteStr='note8' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={18}>
        {/* <Pattern5 setShowCreateInput={props.setShowCreateInput} note='13(a)'  FinalStr='SET_NOTE13A' NoteStr='note13A' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}/> */}
        <Note8 heading={"Note - Instruments entirely equity in nature"} setShowCreateInput={props.setShowCreateInput} note='41'  FinalStr='SET_NOTE8' NoteStr='note8' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
        {/* <Pattern5 setShowCreateInput={props.setShowCreateInput} note='41'  FinalStr='SET_NOTE13A' NoteStr='note13A' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}/> */}
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={19}>
        <div style={heading}>
          {/* some heading here */}
          <p style={headingText} >Note - Share application money pending allotment</p>
        </div>
        {/* < Note4 setShowCreateInput={props.setShowCreateInput} note='12(b)' setRandom={props.setStr} setMath={setMath} FinalStr='SET_NOTE12B' NoteStr='note12B' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}/> */}
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={20}>
        <div style={heading}>
          <p style={headingText} >Note - Other equity</p>
        </div>
        {/* < Note4 setShowCreateInput={props.setShowCreateInput} note='12(c)' setRandom={props.setStr} setMath={setMath} FinalStr='SET_NOTE12C' NoteStr='note12C' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}/> */}
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={21}>
        <div style={heading}>
          {/* some heading here */}
          <p style={headingText} >Note - Non Controlling Interest</p>
        </div>
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={22}>
        <div style={heading}>
          {/* some heading here */}
          <p style={headingText} >Note - Financial Liabilities - Borrowings</p>
        </div>
          <Pattern5b setShowCreateInput={props.setShowCreateInput} note='13(a)' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={23}>
        <Pattern5 heading={"Note - Financial liabilities - Other Financial Liabilities"} setShowCreateInput={props.setShowCreateInput} note='13(b)' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={24}>
      <Pattern5 heading={"Note - Provisions"} name="" setShowCreateInput={props.setShowCreateInput} note = '14'  FinalStr='SET_NOTE14' NoteStr='note14' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
      </TabPanel>
      {/* <TabPanel  className={classes.TabPanel} value={value} index={25}>
        <div style={heading}>
          <p style={headingText} >Note - Employee benefit obligations</p>
        </div>
        < Pattern6 name="" setShowCreateInput={props.setShowCreateInput} note = '15'  FinalStr='SET_NOTE15' NoteStr='note15' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}/>
      </TabPanel> */}
      <TabPanel  className={classes.TabPanel} value={value} index={25}>
        <Note8 heading={"Note - Current tax assets"} setShowCreateInput={props.setShowCreateInput} note='11(a)'  FinalStr='SET_NOTE8' NoteStr='note8' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={26}>
        <Note4 heading={"Note - Deferred tax liabilities"} setShowCreateInput={props.setShowCreateInput} note='16' setRandom={props.setStr} setMath={setMath} FinalStr='SET_NOTE16' NoteStr='note16' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={27}>
          <Note8 heading={"Note - Liabilities directly associated with assets classified as held for sale"} setShowCreateInput={props.setShowCreateInput} note='33'  FinalStr='SET_NOTE33' NoteStr='note33' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
          {/* < Pattern7 setShowCreateInput={props.setShowCreateInput} note = '18'  FinalStr='SET_NOTE18' NoteStr='note18' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}/> */}
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={28}>
          <Pattern7 heading={"Note - Other Non-Current Liabilities"} setShowCreateInput={props.setShowCreateInput} note = '18(b)'  FinalStr='SET_NOTE18(b)' NoteStr='note18' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={29}>
        {/* <NotePayble setShowCreateInput={props.setShowCreateInput} note = '13(c)'  FinalStr='SET_NOTE13C' NoteStr='note13C' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}/> */}
        <Pattern5 heading={"Note - Financial Liabilities - Trade Payable"} name="" setShowCreateInput={props.setShowCreateInput} note = '13(c)'  FinalStr='SET_NOTE13C' NoteStr='note13C' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={30}>
        <Note8 heading={"Note - Contract Liabilities"} setShowCreateInput={props.setShowCreateInput} note='18A'  FinalStr='SET_NOTE19' NoteStr='note19' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
        {/* <Pattern6 name="" setShowCreateInput={props.setShowCreateInput} note = '18A'  FinalStr='SET_NOTE6AA' NoteStr='note6AA' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}/> */}
      </TabPanel>
      <TabPanel  className={classes.TabPanel} value={value} index={31}>
          <Pattern7 heading={"Note - Current tax Liabilities"} setShowCreateInput={props.setShowCreateInput} note = '17'  FinalStr='SET_NOTE18' NoteStr='note18' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
      {/* < Note8 setShowCreateInput={props.setShowCreateInput} note='17' FinalStr='SET_NOTE12B' NoteStr='note12B' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}/> */}
      </TabPanel> 
      <TabPanel  className={classes.TabPanel} value={value} index={32}>
      < Note8 heading={"Note - Other Current Liabilities"} setShowCreateInput={props.setShowCreateInput} note='19'  FinalStr='SET_NOTE19' NoteStr='note19' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
      </TabPanel> 
      {/* <TabPanel  className={classes.TabPanel} value={value} index={33}>
        <div style={heading}>
          <p style={headingText} >Note - Liabilities directly associated with assets classified as held for sale</p>
        </div>
      < Note8 setShowCreateInput={props.setShowCreateInput} note='33'  FinalStr='SET_NOTE33' NoteStr='note33' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}/>
      </TabPanel>  */}

      <TabPanel  className={classes.TabPanel} value={value} index={33}>
        <Note4 heading={"Note - Deferred Tax Assets"} setShowCreateInput={props.setShowCreateInput} note='7'  setRandom={props.setStr} setMath={setMath} FinalStr='SET_NOTE7' NoteStr='note7' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
      </TabPanel>

      <TabPanel  className={classes.TabPanel} value={value} index={34}>
        <div style={heading}>
          <p style={headingText} ></p>
        </div>
        <Note8 heading={"Note - Other non-current Assets"} setShowCreateInput={props.setShowCreateInput} note='8'  FinalStr='SET_NOTE8' NoteStr='note8' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
      </TabPanel>

      <TabPanel  className={classes.TabPanel} value={value} index={35}>
        <Note8 heading={"Note - Bank balances other than above"} setShowCreateInput={props.setShowCreateInput} note='6(z)'  FinalStr='SET_NOTE8' NoteStr='note8' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}projectData={props.projectData}/>
      </TabPanel>

      {/* <TabPanel  className={classes.TabPanel} value={value} index={36}>
        <div style={heading}>
          <p style={headingText} >Note - Current tax assets</p>
        </div>
        <Note8 setShowCreateInput={props.setShowCreateInput} note='11(a)'  FinalStr='SET_NOTE8' NoteStr='note8' setSid={props.setSid} setNid={props.setNid} note4={props.note4} setNoteNum={props.setNoteNum}/>
      </TabPanel> */}

      
    </div>
  );
}
        // <div style={heading}>
        //   {/* some heading here */}
        //   <p style={headingText} >Note - Property, Plant & Equipment</p>
        // </div>